import { render, staticRenderFns } from "./Form_Details.vue?vue&type=template&id=92ec9fa8"
import script from "./Form_Details.vue?vue&type=script&lang=js"
export * from "./Form_Details.vue?vue&type=script&lang=js"
import style0 from "./Form_Details.vue?vue&type=style&index=0&id=92ec9fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports